<template>
    <div class="compare-responsible-employees">
        <div class="row">
            <div :class="selectedRow ? 'col-lg-3' : 'col-lg-9'">
                <div class="placeholder fit-content">
                    <div class="placeholder__heading">
                        <!--<d-tooltip placement="left" identifier="employees.employeeSkills" />-->
                        Ansvarlige
                    </div>
                    <div class="placeholder fit-content">

                        <vue-good-table
                            :columns="columns"
                            :rows="rows"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="sortOptions"
                            :styleClass="styleClass"
                            @on-row-click="selectEmployee"
                            :row-style-class="selectedRowClass"
                            v-if="!loading"
                        >
                            <div slot="emptystate">
                                Ingen data. Husk at angive i indstillingerne hvilke medarbejdere, der skal listes her
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                                    {{ props.row.coverage_percent | coveragePercent }} 
                                    <div
                                        v-if="props.row.coverage_percent !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'total_revenue'">
                                    {{ props.row.total_revenue | currency}}
                                </div>
                                <div v-else-if="props.column.field == 'total_coverage'">
                                    <!--<project-tooltip :project="props.row" />-->
                                    {{ props.row.total_coverage | currency}}
                                </div>
                                <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                                    {{ props.row.coverage_per_hour | currency }} 
                                    <div
                                        v-if="props.row.coverage_per_hour !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                                    />
                                </div>
                                <div v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                        <box-loading height="350" v-else />

                    </div>
                </div>
            </div>
            <div :class="selectedRow ? 'col-lg-9' : 'col-lg-3'">
                <div class="info" v-if="!selectedRow">
                    Vælg en ansvarlig for at se et overblik over de enkelte opgaver og opgavetyper her
                </div>
                <div v-if="selectedRow">
                    <div style="margin-bottom:5px;">
                        <a href="javascript:void(0)" @click="selectedRow = null" style="text-decoration:none;color:#172b43;font-weight:600;">
                            <i class="far fa-times" /> Luk
                        </a>
                    </div>
                </div>
                <responsible-project-types :data="selectedRow" v-if="selectedRow" />
                <!--<employee-skills-single :data="selectedRow" v-else />-->
            </div>
        </div>

    </div>
</template>

<script>
import * as employeeService from '@/services/employeeService'

export default {
    data () {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [
                { label: 'Ansvarlig', field: 'name' },
                { label: 'Antal opgaver', field: 'total_projects', type: 'number' },
                { label: 'Omsætning', field: 'total_revenue', type: 'number' },
                { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' },
                { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' },
                { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.selectedRow = null
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid
            }
            employeeService.compareResponsibleEmployees(params, (response) => {
                console.log(response.data)
                this.rows = response.data
                this.$emit('finishedLoading', this.rows.length)
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        selectEmployee (employee) {
            this.selectedRow = employee.row
        },
        selectedRowClass (row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected'
            }
        }
    },
    components: {
        'responsible-project-types': require('./components/responsibleProjectTypes.vue')
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// compareResponsibleEmployees.vue?6431e88b